import { useState } from "preact/hooks";
import { authPost } from "../../api/client.ts";
import type { AuthStep } from "../../api/types.gen.ts";
import { SLOT, t } from "../../i18n/index.ts";
import { location } from "../../lib/router.ts";
import { Button } from "../../ui/Button.tsx";
import { Field, Form, Input } from "../../ui/form.tsx";
import { Slotted } from "../../ui/misc.tsx";
import { authPath, next, useSubmit } from "./flow.ts";
import { AuthFrame, AuthLink, FormError } from "./frame.tsx";

/** The code from the email: to verify a new account's email, or to sign in without a password. */
export function Code() {
  const email = location.value.searchParams.get("email") ?? "";
  const [code, setCode] = useState("");
  const [resent, setResent] = useState(false);
  const enter = useSubmit(async () => next(await authPost<AuthStep>("/code", { code })));
  const resend = useSubmit(async () => {
    setResent(false);
    await authPost<AuthStep>("/magic", { email });
    setResent(true);
  });
  return (
    <AuthFrame
      title={t("auth.code.title")}
      lede={
        <Slotted text={t("auth.code.lede", { email: SLOT })}>
          <strong class="font-medium text-zinc-900">{email}</strong>
        </Slotted>
      }
      footer={<AuthLink href={authPath("/signin", { email })}>{t("auth.code.otherEmail")}</AuthLink>}
    >
      <FormError error={enter.error ?? resend.error} />
      {resent ? (
        <p role="status" class="mb-4 rounded-md bg-green-50 px-4 py-3 text-sm text-green-800">
          {t("auth.code.resent")}
        </p>
      ) : null}
      <Form class="flex flex-col gap-4" onSubmit={enter.submit}>
        <Field label={t("auth.code.label")}>
          <Input
            autocomplete="one-time-code"
            inputMode="numeric"
            required={true}
            class="text-center font-mono text-lg tracking-[0.4em]"
            value={code}
            onValue={setCode}
          />
        </Field>
        <Button variant="primary" submit={true} busy={enter.busy} class="w-full">
          {t("auth.continue")}
        </Button>
      </Form>
      {email ? (
        <div class="mt-4 text-center">
          <Button variant="ghost" size="sm" busy={resend.busy} onClick={resend.submit}>
            {t("auth.code.resend")}
          </Button>
        </div>
      ) : null}
    </AuthFrame>
  );
}
